import React from 'react'
import ServiceSection from '../../Components/mumbai/ServiceSection'
import ServiceNowConsultingSlider from '../../Components/mumbai/ServiceNowConsultingSlider'
import MaximizeModal from '../../Components/mumbai/MaximizeModal'
import IndustriesSliderSection from '../../Components/mumbai/IndustriesSliderSection'
import ServiceNowBannerSection from '../../Components/mumbai/ServiceNowBannerSection'
import { Helmet } from 'react-helmet-async'
import HireDeveloper from '../../Components/hire/HireDeveloper'
import HeroServiceSection from '../../Components/mumbai/HeroServiceSection'
import LocationForm from '../../Components/mumbai/LocationForm'
import WhyChoose from '../../Components/mumbai/WhyChoose'
import EngagementModels from '../../Components/hire/EngagementModels'
import ServiceNowLeadForm from '../../Components/ServiceNowLeadForm'
const wellbeingData = [
    {
        id: 1,
        title: "Comprehensive Support",
        description: "Our dedicated team supports Monaco businesses with responsive service, trusted expertise, and ongoing guidance to ensure smooth operations and long-term success.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 2,
        title: "Industry Expertise ",
        description: "Mobikode delivers tailored digital solutions that help Monaco's healthcare, finance, education, retail, real estate, logistics, and growing businesses innovate, streamline operations, and achieve sustainable growth with confidence.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 3,
        title: "Customized Solutions",
        description: "Every business in Monaco is unique. We create tailored digital solutions that simplify operations, support your goals, and drive sustainable long-term business growth with confidence.",
        image: "/assets/mumbai/img2.png"
    },

];


const consultingData = [
    {
        id: 1,
        title: "ServiceNow Consulting",
        desc: "Strategic platform advisory, maturity assessments, and digital roadmap formulation tailored to optimize your ServiceNow enterprise landscape.",
        link: "/service/servicenow-consulting",
    },
    {
        id: 2,
        title: "ServiceNow Implementation",
        desc: "End-to-end multi-module deployment, configuration, and workflow automation executed with best practices for swift enterprise adoption.",
        link: "/service/servicenow-implementation",
    },
    {
        id: 3,
        title: "ServiceNow ITSM",
        desc: "Modernize service desk operations, incident triage, change management, and request fulfillment through intelligent IT service management.",
        link: "/service/servicenow-itsm",
    },
    {
        id: 4,
        title: "ServiceNow ITOM & CMDB",
        desc: "Gain real-time infrastructure visibility, build an accurate healthy CMDB, and automate event remediation with predictive discovery.",
        link: "/service/servicenow-itom-cmdb",
    },
    {
        id: 5,
        title: "ServiceNow CSM",
        desc: "Deliver connected customer experiences by breaking down silos across front, middle, and back-office teams with proactive issue resolution.",
        link: "/service/servicenow-csm",
    },
    {
        id: 6,
        title: "ServiceNow HRSD",
        desc: "Elevate employee experiences with streamlined onboarding, unified life-event journeys, and self-service HR service delivery portals.",
        link: "/service/servicenow-hrsd",
    },
    {
        id: 7,
        title: "ServiceNow AI & Automation",
        desc: "Leverage Generative AI, Now Assist, machine learning models, and virtual agents to automate complex multi-departmental workflows.",
        link: "/service/servicenow-ai-automation",
    },
    {
        id: 8,
        title: "ServiceNow Integration",
        desc: "Seamlessly integrate your ServiceNow instance with ERPs, CRMs, cloud platforms, and legacy systems via Integration Hub and custom APIs.",
        link: "/service/servicenow-integration",
    },
    {
        id: 9,
        title: "ServiceNow Custom Development",
        desc: "Build scalable, tailor-made applications and intuitive enterprise service portals using ServiceNow App Engine and UI Builder.",
        link: "/service/servicenow-custom-development",
    },
    {
        id: 10,
        title: "ServiceNow Managed Services",
        desc: "Continuous proactive support, performance monitoring, release upgrades, technical debt reduction, and platform governance.",
        link: "/service/servicenow-managed-services",
    },
    {
        id: 11,
        title: "ServiceNow Resource Augmentation",
        desc: "Scale your delivery bandwidth with certified ServiceNow architects, developers, technical consultants, and flexible dedicated pods.",
        link: "/service/servicenow-resource-augmentation",
    },
    {
        id: 12,
        title: "ServiceNow Center of Excellence (COE)",
        desc: "Build a scalable ServiceNow ecosystem with strong governance, platform standardization, continuous improvement, and enterprise-wide innovation.",
        link: "/service/servicenow-coe",
    },
];

const industriesData = [
    {
        id: 1,
        title: "Financial Services",
        desc: "At Mobikode, we empower Monaco's financial institutions with secure, innovative technology that simplifies operations, enhances client experiences, strengthens compliance, and supports confident, sustainable business growth.",
        image: "/assets/mumbai/item1.png"
    },
    {
        id: 2,
        title: "eCommerce ",
        desc: "At Mobikode, we help Monaco's eCommerce businesses grow with innovative, reliable digital solutions that enhance customer experiences, streamline operations, and drive sustainable long-term success.",
        image: "/assets/mumbai/item2.png"
    },
    {
        id: 3,
        title: "Insurance ",
        desc: "Helping Monaco's insurance companies streamline operations, enhance customer experiences, simplify claims and policy management, and achieve sustainable growth with secure, reliable, and innovative digital solutions tailored to their needs.",
        image: "/assets/mumbai/item3.png"
    },
    {
        id: 4,
        title: "Manufacturing",
        desc: "Mobikode helps manufacturers in Monaco simplify operations, boost productivity, automate workflows, and embrace smart digital solutions that drive efficiency, innovation, and sustainable long-term business growth.",
        image: "/assets/mumbai/item4.png"
    },
    {
        id: 5,
        title: "Retail & Consumer Goods",
        desc: "At Mobikode, we empower Monaco's retail and consumer brands with smart digital solutions that enhance customer experiences, streamline operations, and drive sustainable business growth with confidence.",
        image: "/assets/mumbai/item5.png"
    },
    {
        id: 6,
        title: "Healthcare & Life Sciences",
        desc: "At Mobikode, we help Monaco's healthcare and life sciences organizations enhance patient care, simplify operations, accelerate innovation, and deliver secure digital experiences that improve health outcomes.",
        image: "/assets/mumbai/item6.png"
    },
    {
        id: 7,
        title: "Media & Communications ",
        desc: "Mobikode empowers Monaco's media and communications businesses to deliver engaging digital experiences, streamline operations, strengthen audience connections, and accelerate sustainable growth through innovative, secure, and human-centered technology solutions.",
        image: "/assets/mumbai/item7.png"
    },
    {
        id: 8,
        title: "Logistics & Transportation ",
        desc: "Mobikode empowers Monaco’s logistics and transportation businesses with smart digital solutions that simplify operations, enhance delivery experiences, and support sustainable growth through technology built around real business needs.",
        image: "/assets/mumbai/item8.png"
    },
    {
        id: 9,
        title: "Technology",
        desc: "Empowering Monaco’s technology companies with innovative digital solutions, Mobikode blends creativity, expertise, and trusted technology to transform ideas into meaningful business growth and lasting impact.",
        image: "/assets/mumbai/item9.png"
    },
    {
        id: 10,
        title: "Non Profit",
        desc: "Mobikode empowers non-profit organizations in Monaco with smart digital solutions that simplify operations, strengthen community connections, and help create meaningful, lasting social impact.",
        image: "/assets/mumbai/item10.png"
    },
    {
        id: 11,
        title: "Professional Services ",
        desc: "Mobikode helps professional service businesses in Monaco streamline operations, adopt smart digital solutions, and deliver seamless client experiences through reliable, customized technology built for growth.",
        image: "/assets/mumbai/item11.png"
    },
    {
        id: 12,
        title: "Real Estate ",
        desc: "Mobikode empowers Monaco’s real estate businesses with smart digital solutions that streamline operations, enhance customer experiences, and build meaningful connections between developers, agents, and buyers.",
        image: "/assets/mumbai/item12.png"
    },

];

function Monaco() {
    return (
        <div>
            <Helmet>
                <title>
                    ServiceNow Consulting in Monaco | Enterprise IT Solutions | Mobikode
                </title>

                <meta
                    name="description"
                    content="Mobikode offers ServiceNow consulting in Monaco to streamline IT service management, automate business processes, integrate enterprise platforms, and improve operational efficiency with scalable technology solutions."
                />

                <meta
                    name="keywords"
                    content="ServiceNow Consulting Monaco, ServiceNow Consultant Monaco, ServiceNow ITSM Monaco, ServiceNow Enterprise Solutions Monaco, ServiceNow Business Automation Monaco, ServiceNow Workflow Automation Monaco, ServiceNow Implementation Monaco, ServiceNow Integration Monaco, ServiceNow Managed Services Monaco, ServiceNow Enterprise AI & ServiceNow Consulting Monaco"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-monaco"
                />

                <meta
                    property="og:title"
                    content="ServiceNow Consulting in Monaco | Enterprise IT Solutions | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Enhance business operations with Mobikode's ServiceNow consulting services in Monaco. Optimize ITSM, automate workflows, connect enterprise systems, and create efficient digital processes."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-monaco"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/monaco/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="ServiceNow Consulting in Monaco | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Discover ServiceNow solutions in Monaco for IT service management, workflow automation, enterprise integration, and streamlined digital operations with Mobikode."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/monaco/bg1.png"
                />
            </Helmet>
            <HeroServiceSection bgImage="/assets/mumbai/bg1.png" title="Leverage ServiceNow Consulting in Monaco" description="Partner with Mobikode’s ServiceNow experts in Monaco to simplify daily operations, empower your teams, automate business processes, and achieve sustainable growth through intelligent digital transformation. Trusted by Startups and Leading Companies Worldwide" />
            <ServiceNowLeadForm bgImage="/assets/mumbai/Monaco.png" />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <WhyChoose />
            <MaximizeModal wellbeingData={wellbeingData} />
            <EngagementModels />
            <IndustriesSliderSection industriesData={industriesData} />
            {/* <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/mumbai/bg1.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>

                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[900px] mt-auto md:mt-0">
                        <h1 className="text-white font-[600] text-[28px] sm:text-[36px] md:text-[50px] lg:text-[60px] font-sora leading-[1.2] lg:leading-[1.1] mb-[12px] lg:mb-[22px] drop-shadow-xl tracking-wide text-left">
                            Leverage ServiceNow Consulting in Monaco
                        </h1>
                        <p className="text-[#FFFFFF] max-w-[800px] w-full text-[14px] sm:text-[16px] md:text-[18px] leading-[20px] md:leading-[22px] lg:leading-[24px] font-graphik font-light tracking-wider text-left opacity-90 lg:opacity-100">
                            Partner with Mobikode's ServiceNow experts in Monaco to streamline operations, boost productivity, automate workflows, and achieve sustainable business growth with confidence.
                        </p>
                    </div>
                </div>
            </section> */}
            {/* <ServiceSection image={"/assets/mumbai/Monaco.png"}
                text={"At Mobikode, we help businesses in Monaco unlock the full potential of ServiceNow with tailored consulting and smart automation solutions. From seamless implementation and customization to integrations and ongoing support, our experts simplify operations, enhance user experiences, and streamline workflows. We deliver secure, scalable ServiceNow solutions that drive efficiency, support digital transformation, and enable sustainable business growth."}
                title={"ServiceNow Consulting"} />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <MaximizeModal wellbeingData={wellbeingData} />
            <IndustriesSliderSection industriesData={industriesData} />
            <ServiceNowBannerSection imgs={"/assets/mumbai/img3.png"}
                title="ServiceNow Consulting Services"
                text="Mobikode helps businesses in Monaco unlock ServiceNow’s full potential through tailored consulting, intelligent automation, and seamless solutions that simplify operations, boost efficiency, and enhance digital experiences." />
            <HireDeveloper /> */}
        </div>
    )
}

export default Monaco
